<template>
  <button
    :type="type"
    class="inline-flex items-center px-3 py-2 text-sm font-medium leading-4 text-white transition bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-25">
    <slot></slot>
  </button>
</template>

<script >
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      type: {
        type: String,
        default: 'submit',
      },
    },
  });
</script>
